import { GenericType } from "../base/edl-generic-type.model";
import { ObservationTypes } from "./observation-types.enum";

export class CommentLookUpTypes {
  public static WalkthroughType: string = "Domain"
  public static WalkthroughOptions: Array<any> = [
    { Label: "Domain 1", Value: "1" },
    { Label: "Domain 2", Value: "2" },
    { Label: "Domain 3", Value: "3" },
    { Label: "Domain 4", Value: "4" }
  ]

  public static AnecdotalType: string = "Domain"
  public static AnecdotalOptions: Array<any> = [
    { Label: "Domain 1", Value: "1" },
    { Label: "Domain 2", Value: "2" },
    { Label: "Domain 3", Value: "3" },
    { Label: "Domain 4", Value: "4" }
  ]

  public static getLabel(observationType?: GenericType): string {
    switch (observationType) {
      case ObservationTypes.Walkthrough:
        return CommentLookUpTypes.WalkthroughType;
      case ObservationTypes.Anecdotal:
        return CommentLookUpTypes.AnecdotalType;
      default:
        return "";
    }
  }

  public static getOptions(observationType?: GenericType) {
    switch (observationType) {
      case ObservationTypes.Walkthrough:
        return CommentLookUpTypes.WalkthroughOptions;
      case ObservationTypes.Anecdotal:
        return CommentLookUpTypes.AnecdotalOptions;
      default:
        return [];
    }
  }
}

